import { crearDisposicion } from "./crearDisposicion";
import { crearBotones } from "./crearBotones";
import { crearCajaTragamonedas } from "./crearCajaTragamonedas";
import { crearCartelesTematica } from "./crearCartelesTematica";
import { crearFondo } from "./crearFondo";
import { crearPalanca } from "./crearPalanca";
import { crearValoresTragamonedas } from "./crearValoresTragamonedas";

/**
 * Carga todos los assets del juego de la ruleta
 * @param {*} scene 
 */
export function creacionElementosPrincipal(scene) {

  //crearDisposicion(scene);
  crearBotones(scene);
  crearCajaTragamonedas(scene);
  crearCartelesTematica(scene);
  crearFondo(scene);
  crearPalanca(scene);
  crearValoresTragamonedas(scene);

}